module.exports = __webpack_public_path__ + "static/img/home-top.20280aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/home-top.jpg
// module id = 9G00
// module chunks = 0